import { InjectionToken } from '@angular/core';
import { TaskInterface } from '@campus/dal';

export interface StudentTaskServiceInterface {
  isTaskFinished(task: TaskInterface): boolean;
}

export const STUDENT_TASK_SERVICE_TOKEN = new InjectionToken<StudentTaskServiceInterface>('StudentTaskService');
